



























import { Component, PropSync, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';

import SwapCreateGroup from '@/components/manageGroup/SwapCreateGroup.vue';
import SwapMemberGroup from '@/components/manageGroup/SwapMemberGroup.vue';
import SwapSetGroup from '@/components/manageGroup/SwapSetGroup.vue';

import * as c_Interface from '@/interface/components/manageGroups';

const namespace = 'manageGroup';

@Component({
  components: {
    SwapCreateGroup,
    SwapMemberGroup,
    SwapSetGroup,
  },
})
export default class CreateGroup extends Vue {
  @PropSync('dialogVisible', { type: Boolean, default: false }) propsDialogVisible!: boolean;
  @Action('createLab', { namespace }) c_createLab!: any;

  public ruleForm: c_Interface.CreateGroupPayload = {
    name: '',
    organization: '',
    inventoryEdit: 'ALL_EDIT',
    members: [
      { email: '', isAdmin: false },
      { email: '', isAdmin: false },
      { email: '', isAdmin: false },
    ],
  };
  public currentActive = 1;

  get swapComponent(): string {
    let componentName = '';
    switch (this.currentActive) {
      case 1:
        componentName = 'SwapCreateGroup';
        break;
      case 2:
        componentName = 'SwapMemberGroup';
        break;
      case 3:
        componentName = 'SwapSetGroup';
        break;
    }

    return componentName;
  }

  modalClose() {
    this.$emit('emitCreateModalClose');
  }
}
